// Shared "Lees meer" toggle for clamped text (product short descriptions).
// The button stays hidden unless the text actually overflows its line clamp.
// Used by the single product page (on load) and the quick view (after AJAX).
export function initReadMore(root = document) {
  root.querySelectorAll('.phent-readmore__text').forEach((text) => {
    const toggle = text.parentElement.querySelector('.phent-readmore__toggle');
    if (!toggle || toggle.dataset.bound) return;
    if (text.scrollHeight <= text.clientHeight + 1) return;

    toggle.dataset.bound = '1';
    toggle.classList.remove('hidden');
    toggle.classList.add('inline-flex');
    toggle.addEventListener('click', () => {
      const expanded = !text.classList.toggle('line-clamp-6');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.querySelector('span').textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
    });
  });
}

// app.js can be loaded async, so DOMContentLoaded may already have fired.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initReadMore());
} else {
  initReadMore();
}
// Re-check once everything (webfonts) is in, in case line heights shifted.
window.addEventListener('load', () => initReadMore());
